import type { SVGProps } from "react";

export const DragVertical = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="size-4"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M6.74 13.217a1.348 1.348 0 1 1-2.697 0 1.348 1.348 0 0 1 2.696 0ZM5.39 7.152a1.348 1.348 0 1 0 0 2.696 1.348 1.348 0 0 0 0-2.696Zm0-4.717a1.348 1.348 0 1 0 0 2.696 1.348 1.348 0 0 0 0-2.696Zm5.392 9.435a1.348 1.348 0 1 0 0 2.695 1.348 1.348 0 0 0 0-2.695Zm0-4.718a1.348 1.348 0 1 0 0 2.696 1.348 1.348 0 0 0 0-2.696Zm0-4.717a1.348 1.348 0 1 0 0 2.696 1.348 1.348 0 0 0 0-2.696Z"
      />
    </svg>
  );
};
